module.exports = __webpack_public_path__ + "static/media/arrow-alt-right.0e562b43.svg";